<template>
    <div class="wrapper" >
            <div v-for="(item,index) in orderList" :key="index">
                <div class="list_item_container bottom_line">
                    <div>
                        <span class="item_title">{{orderTypeName}}</span>
                        <div v-if="orderType == 1">
                            <div class="item_left_container">
                                <span class="item_project">会议室名</span>
                                <span class="item_content">{{item.meetingName}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">所属项目</span>
                                <span class="item_content">{{item.marketName}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">预定时间</span>
                                <span class="item_content">{{item.reserveTime}}</span>
                            </div>
                        </div>
                        <div v-else-if="orderType == 2">
                            <div class="item_left_container">
                                <span class="item_project">工单编号</span>
                                <span class="item_content">{{item.repairNo}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">项目名称</span>
                                <span class="item_content">{{item.marketName}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">报修类型</span>
                                <span class="item_content">{{item.repairType}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">创建日期</span>
                                <span class="item_content">{{item.repairTime|formatTime}}</span>
                            </div>
                        </div>
                        <div v-else-if="orderType == 3">
                            <div class="item_left_container">
                                <span class="item_project">月份</span>
                                <span class="item_content">{{item.billCycle}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">账单编号</span>
                                <span class="item_content">{{item.arrearsNo}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">客商名称</span>
                                <span class="item_content">{{item.companyName}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">所属项目</span>
                                <span class="item_content">{{item.marketName}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">缴费日期</span>
                                <span class="item_content">{{item.payTime|formatTime}}</span>
                            </div>
                        </div>
                        <div v-else-if="orderType == 4">
                            <div class="item_left_container">
                                <span class="item_project">停车场</span>
                                <span class="item_content">{{item.parkName}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">所属项目</span>
                                <span class="item_content">{{item.marketName}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">缴费月数</span>
                                <span class="item_content">{{item.paymentMonth}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">缴费日期</span>
                                <span class="item_content">{{item.payTime|formatTime}}</span>
                            </div>
                        </div>
                        <div v-else-if="orderType == 5">
                            <div class="item_left_container">
                                <span class="item_project">停车场</span>
                                <span class="item_content">{{item.parkName}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">所属项目</span>
                                <span class="item_content">{{item.marketName}}</span>
                            </div>
                            <!-- <div class="item_left_container">
                                <text class="item_project">停车时长</text>
                                <text class="item_content">{{item.parkingTime}}</text>
                            </div> -->
                            <div class="item_left_container">
                                <span class="item_project">进场时间</span>
                                <span class="item_content">{{item.inTime|formatTime}}</span>
                            </div>
                            <div class="item_left_container">
                                <span class="item_project">缴费时间</span>
                                <span class="item_content">{{item.payTime|formatTime}}</span>
                            </div>

                        </div>
                    </div>
                    <div class="row_container">
                        <span class="item_price">{{item.payAmount|returnFloat}}</span>
                        <span class="unit">元</span>
                    </div>
                </div>
            </div>
    </div>
</template>
<style scoped>
    .wrapper {
        flex: 1;
    }

    .unit {
        font-size: 24px;
        margin-top: 8px;
    }

    .list_item_container {
        margin-left: 40px;
        margin-right: 40px;
        width: 670px;
        display: flex;
        padding-top: 28px;
        padding-bottom: 28px;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
    }

    .item_left_container {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        margin-top: 14px;
        flex-wrap: wrap;
    }

    .row_container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }

    .item_title {
        width: 112px;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
    }

    .item_project {
        width: 100px;
        height: 34px;
        font-size: 24px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 34px;
    }

    .item_content {
        width: 336px;
        font-size: 24px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 34px;
        margin-left: 28px;
    }

    .item_price {
        font-size: 36px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
    }

    .bottom_line {
        border-bottom-style: solid;
        border-bottom-width: 2px;
        border-bottom-color: #EAEAEA;
    }
</style>
<script>
    import storage from '../../utils/storage';
    import util from '../../utils/util';
    export default {
        components: {
        },
        data: function() {
            return {
                // orderType 1：会议室，2：物业报修；3：在线账单；4：个人月租；5：临停缴费
                orderType: 0,
                orderList: [],
                orderTypeName: ""
            };
        },
        created() {
            var str = storage.getS("InvoiceInfo_orderList")
            console.log(str);
            let query = this.$route.query;
            this.orderType = query.orderType;
            let orderTypeName = decodeURI(query.orderTypeName);
            this.orderTypeName = orderTypeName;
            this.orderList = JSON.parse(str);
            console.log( this.orderType);
            console.log( this.orderList);
        },
        mounted() {

        },

        methods: {
        },
        filters: {
             returnFloat(val){
                if(!val){
                    return '0'
                }
                return Number(val).toFixed(2)
            },
            formatTime: function (value) {
                // let time = configObj.dataFormat(new Date(value), 'yyyy-MM-dd hh:mm');
                // return time;
                return util.formatTime(new Date(value),10)
            }
        }
    }
</script>